import styled from "styled-components";

export const Container = styled.div`
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  justify-content: space-between;
  flex-wrap: nowrap;
  min-height: 100vh;
  color: var(--primary);
  background-color: var(--secondary);
`;

export const Item = styled.div`
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: center;
  flex-wrap: wrap;
  width:100%;
  border: 1px solid var(--primary);
  color: var(--secondary);
  background-color: var(--darkBlue);
  border-radius: 2rem;
  padding: 2rem 3rem;
  margin: 1rem 0;
  cursor: pointer;
  gap: 2rem;
  div{
    width: 100%;
    display: flex;
    flex-direction: row;
    align-items: center;
    justify-content: center;
    flex-wrap: wrap;
  }
`;

export const ItemForm = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  width:100%;
  border: 1px solid var(--primary);
  color: var(--primary);
  border-radius: 2rem;
  padding: 1rem 1rem;
  margin: 1rem 0;
  cursor: pointer;
  div{
    width: 100%;
    padding: 0;
    margin: 0;
    display: flex;
    flex-direction: row;
    align-items: center;
    justify-content: center;
    flex-wrap: wrap;
  }

  border: 0.1rem solid;
  border-radius: 2rem;
  box-shadow: 0.3rem 0.3rem 0.3rem var(--darkBlue);
  background-color: var(--softGray);

`;

export const NFinalizado = styled.div`
color: var(--hardRed);
font-weight: bold;
`;

export const Finalizado = styled.div`
color: var(--darkBlue);
font-weight: bold;
`;


export const ItemSelect = styled.div`
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: center;
  flex-wrap: wrap;
  width:100%;
  color: var(--primary);
  background-color: var(--secondary);
  border-radius: 2rem;
  margin: 1rem 0;
  gap: 2rem;
  div{
    cursor:pointer
  }
`;

export const Text = styled.div`
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  justify-content: flex-start;
  flex-wrap: wrap;
  width:80%;
  padding: 0;
`;

export const Button = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: space-around;
  flex-wrap: wrap;
  width:19%;
  height: 100%;
  padding: 0;
`;

export const ButtonGroup = styled.div`
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: center;
  flex-wrap: wrap;
  width:100%;
  gap: 2rem;
`;